import React from 'react';
import { Navigate } from 'react-router-dom';
import * as ROUTES from '../constants';

function DefaultRedirect() {
  return <Navigate to={ROUTES.DASHBOARD} />;
}

export default DefaultRedirect;
